<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => this.$router.go(-1)"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Diário Atendimento
        </h1>
      </v-col>
    </v-row>
    <v-col>
      <v-card>
        <v-card-text>
          <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
          <h4>Aluno: {{ matricula?.aluno ? matricula?.aluno.nomecompleto : "- - -" }}</h4>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-text>
          Professor:
          {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
        </v-card-text>
      </v-card>
    </v-col>

    <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
      <form @submit.prevent="createOrUpdate">
        <v-col>
          <v-row>
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Data" rules="required">
                <e-label>Selecione uma data</e-label>
                <input type="hidden" v-model="aulaSelecionada.data" />
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="data"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="aulaSelecionada.data"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      :error-messages="!aulaSelecionada.data ? ['O campo Data é obrigatório'] : []"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data" scrollable :allowed-dates="allowedDates">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false"> Cancelar </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)"> OK </v-btn>
                  </v-date-picker>
                </v-dialog>
              </ValidationProvider>
            </v-col>

            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Horário" rules="required" v-slot="{ errors }">
                <e-label>Selecione um horário</e-label>
                <e-autocomplete
                  :items="horarios"
                  :error-messages="errors"
                  label="Selecione um horário"
                  :item-text="(item) => item.descricao"
                  :item-value="(item) => item.id"
                  v-model="horarioSelecionado"
                  return-object
                  dense
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row v-for="(item, index) in $constants.fichaEducacaoEspecialDiario" :key="index">
            <v-col cols="12">
              <ValidationProvider :name="item.descricao" rules="required" v-slot="{ errors }">
                <e-label>{{ item.descricao }}</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada[item.form]"
                  :error-messages="errors"
                  @input="validate()"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-col cols="12">
            <v-row>
              <v-btn
                color="primary"
                :disabled="submittingForm || invalid"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
            </v-row>
          </v-col>
        </v-col>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required, min, max } from "vee-validate/dist/rules";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel, ValidationObserver, ValidationProvider },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadBasicData();
  },
  data() {
    return {
      horarioSelecionado: null,
      aulaSelecionada: {
        data: null,
        horario_aee_id: null,
        ativade: null,
      },
      form: {
        data: null,
        horario_aee_id: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      ficha: null,
      matricula: null,
      gestao: null,
      modal: false,
      menu: false,
      horarios: [],
      submittingForm: false,
      data: null,
    };
  },
  watch: {
    data(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
    },
    horarioSelecionado(newVal) {
      this.form.horario_aee_id = newVal?.id || null;
    },
  },
  computed: {
    isFormValid() {
      return this.$constants.fichaEducacaoEspecialDiario.every((item) => {
        return this.form[item.form] !== null && this.form[item.form] !== "";
      });
    },
  },

  methods: {
    formatDate(dateString) {
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    async createOrUpdate() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (!this.aulaSelecionada.data) {
        this.$toast.danger("Por favor, selecione uma data");
        return;
      }
      if (!this.horarioSelecionado) {
        this.$toast.danger("Por favor, selecione um horário");
        return;
      }

      this.submittingForm = true;
      try {
        const { id } = this.$route.params;
        const { gestaoDeAulasId } = this.$route.params;
        this.form.id = id;
        this.form.gestao_id = gestaoDeAulasId;
        this.form.data = this.formatDate(this.aulaSelecionada.data);
        this.form.matricula_id = this.matricula?.id;
        this.aulaSelecionada.horario_aee_id = this.horarioSelecionado
          ? this.horarioSelecionado.id
          : null;
        Object.assign(this.form, this.aulaSelecionada);

        await this.$services.educacaoInclusivaService.lancarFichaDeDiarioAtendimentoEdit(this.form);
        if (id) {
          this.$toast.info("Frequência Individual editada!");
        } else {
          this.$toast.info("Frequência Individual criada!");
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$router.go(-1);
        this.submittingForm = false;
      }
    },

    areAllFieldsFilled() {
      return this.$constants.fichaEducacaoEspecialDiario.every((item) => {
        return this.form[item.form] !== null && this.form[item.form] !== "";
      });
    },
    async updateButtonState() {
      await this.$nextTick();
      this.$refs.observer.validate();
    },

    async getFicha() {
      try {
        this.$loaderService.open("Carregando dados...");
        const { id } = this.$route.params;
        const { gestaoDeAulasId } = this.$route.params;
        const { matricula_id } = this.$route.params;
        const response =
          await this.$services.educacaoInclusivaService.carregarFichaDeDiarioAtendimento(
            matricula_id,
            gestaoDeAulasId
          );

        this.gestaoDeAula = response.gestao;

        this.matricula = response.matricula;
        if (this.gestaoDeAula.relacoesDiasHorarios) {
          this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
            (g) => g.dia.id
          );

          this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
          this.horariosSabado = this.horarios;
          this.horariosSabado = this.horariosSabado.map((h) => {
            return {
              id: h.id,
              turno_id: h.turno_id,
              descricao: h.descricao.split(" - ")[0],
              final: h.final,
              inicio: h.inicio,
            };
          });
        }
        if (this.editing) {
          const aulaSelecionada =
            await this.$services.educacaoInclusivaService.carregarFichaDeDiarioAtendimentoEdit(
              parseInt(id, 10)
            );

          this.aulaSelecionada = aulaSelecionada;

          // Aqui o horarioSelecionado deve ser definido
          this.horarioSelecionado =
            this.horarios.find((h) => h.id === aulaSelecionada.horario_aee_id) || null;
        }
        return this.aulaSelecionada;
      } catch (error) {
        this.$handleError(error);
        return null;
      } finally {
        this.$loaderService.close();
      }
    },

    allowedDates(val) {
      const array = [...this.diasPermitidosParaCriarAula];

      if (!array.includes(5)) {
        array.push(5);
      }

      if (
        this.data &&
        new Date(val).toISOString().split("T")[0] ===
          new Date(this.data).toISOString().split("T")[0]
      ) {
        return true;
      }

      return array.includes(new Date(val).getDay());
    },

    async loadBasicData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getFicha();

        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }

        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style></style>
